import { render, staticRenderFns } from "./TopSlot.vue?vue&type=template&id=8257edf4&scoped=true&lang=pug&"
import script from "./TopSlot.ts?vue&type=script&lang=ts&"
export * from "./TopSlot.ts?vue&type=script&lang=ts&"
import style0 from "./TopSlot.vue?vue&type=style&index=0&id=8257edf4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8257edf4",
  null
  
)

export default component.exports